import React from "react";
import styles from "./separator.module.scss";
import classnames from "classnames";

export const Separator: React.FC<{ className?: string; color?: "blue" | "white"; children?: React.ReactNode }> = React.memo(
  ({ className, children, color }) => {
    return (
      <div
        className={classnames(className, styles.separator, styles[color ?? ""], {
          [styles.hasText]: children,
        })}
      >
        {children}
      </div>
    );
  }
);
